import React from "react";
import TrainJourneyEdit from "../components/TrainJourneyEdit";
import { Button } from "semantic-ui-react";
import { trainDetailsToInstruction } from "../utils";

interface Props {
  train: server.dto.LegacyTrain
  onFinished: (newTrain: server.dto.LegacyTrain) => void
  fromItem: server.dto.FromItem
}

const TrainJourneyEditScreen = (props: Props) => {
  const [train, setTrain] = React.useState(trainDetailsToInstruction(props.train));

  const [artistError, setArtistError] = React.useState<boolean>(false);
  const [travellersError, setTravellerError] = React.useState<boolean>(false);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const onSave = async (e) => {
    e.preventDefault();
    if (artistError || isLoading) {
      return;
    }

    const hasNoArtist = train.artistId == null;
    const hasNoTravellers = train.travellerIds.length === 0;

    if (hasNoArtist) {
      setArtistError(true);
      return;
    }

    if (hasNoTravellers) {
      setTravellerError(true);
      return;
    }

    setIsLoading(true);

    // const result = await window.Api.Trains.UpdateTrain(props.train.id, train);
    const result = await window.Api.Trains.UpdateTrainDetails(props.train.id, train);
    props.onFinished(result.data);
  };

  const onTrainChange = (newTrain: server.dto.ModifyTrainDetailsInstruction) => {
    if (newTrain.travellerIds.length > 0) {
      setTravellerError(false);
    }
    if (newTrain.artistId != null) {
      setArtistError(false);
    }

    setTrain(newTrain);
  };

  return <>
    <div className="grow1 scrollbox-auto s1_panel">
      <TrainJourneyEdit
        train={train}
        onTrainChanged={onTrainChange}
        noArtistError={artistError}
        travellersError={travellersError}

        initialArtist={props.train.artist}
        initialTravellers={props.train.travellers}
        initialPhase={props.train.phase}
      />
    </div>

    <div className="flex margin-top justify-end margin-right">
      <div>
        <Button loading={isLoading} primary onClick={onSave}>{RESX.Buttons.btnSave}</Button>
      </div>
    </div>
  </>;
};

export default TrainJourneyEditScreen;